export default "__VITE_ASSET__Xu4aNyPw__"